import { ReportListItemData } from './report-base';

export class CreditReportUserListItem extends ReportListItemData {
  clubuserprogramfeeID: number;
  dob: Date;
  email: string;
  programName: string;
  clubID: number;
  clubProgramID: number;
  clubProgramTypeID: number;
  regStatus: number;
  programStatus: number;
  dateRegistered: Date;
  lastStepCompleted: number;
  clubprogramfeeID: number;
  clubfeepaymentplanID: number;
  nextStep: string;
  amount: number;
  clubuserprogramcreditID: number;
  totalCreditAmount: number;
  creditReason: string;
  creditAddedBy: string;
  creditDateAdded: Date;
  paymentID: number;
  feeName: string;
  creditSpentDate: Date;
  spentCreditAmount: number;
}

export class CreditReport {
  totalNumberOfCredit: number;
  totalCreditAmount: number;
  list: CreditReportUserListItem[];

  constructor(data: any = {}) {
    this.totalCreditAmount = +data.totalCreditAmount;
    this.totalNumberOfCredit = +data.totalNumberOfCredit;
    this.list = data.creditReportUserList ? data.creditReportUserList.map(l => new CreditReportUserListItem(l)) : [];
  }
}



// WEBPACK FOOTER //
// ./src/app/models/reports/credit-report.ts